import React, { useEffect, useState } from "react";
import {
  TextInput,
  SimpleForm,
  required,
  ReferenceInput,
  AutocompleteInput,
  useDataProvider,
  EditProps,
} from "react-admin";
import { AcademicYearResources, GetParam } from "utils/tools";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomEditToolbar from "components/CustomEditToolbar";
import CustomEndDateInput from "components/CustomEndDateInput";
import moment from "moment";
import { reject } from "lodash";
import { typeList } from "./const";
import EditWrapper from "../../components/EditWrapper";

const HolidayEdit = (props: EditProps) => {
  const [holidays, setHolidays] = useState<IHoliday[]>([]);
  const provider = useDataProvider();
  const param = GetParam();

  const { id } = props;

  const breadcrumb = [
    { title: "Schools", link: `/schools` },
    {
      title: "Academic Years",
      link: `/schools/${param.get("schoolId")}/show/4`,
    },
    {
      title: "Holidays",
      link: `/academicYears/${param.get("academicYearId")}/show/2`,
      params: `?schoolId=${param.get("schoolId")}`,
    },
    {
      title: id,
      link: "",
    },
  ];

  const academicYearResources = AcademicYearResources(
    Number(param.get("academicYearId"))
  );

  useEffect(() => {
    provider
      .getList("holidays", {
        filter: { AcademicYearId: Number(param.get("academicYearId")) },
        pagination: {
          page: 1,
          perPage: 1000,
        },
        sort: {
          field: "Id",
          order: "ASC",
        },
      })
      .then(({ data }) => {
        setHolidays(data as IHoliday[]);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let excludeDates: IExcludeDates[] = [];
  let holidaysWithoutSelected = reject(holidays, {
    id: Number(id),
  });

  holidaysWithoutSelected.forEach((holiday: IHoliday) => {
    let temp: IExcludeDates = {
      startDate: holiday.date,
    };

    excludeDates.push(temp);
  });

  return (
    <>
      <EditWrapper
        breadcrumb={breadcrumb}
        customName={{
          resourceName: "Regular Holiday",
          propertyName: "name",
        }}
        {...props}
      >
        <SimpleForm
          toolbar={
            <CustomEditToolbar
              redirectLink={`/academicYears/${param.get(
                "academicYearId"
              )}/show/2?schoolId=${param.get("schoolId")}`}
            />
          }
        >
          <SanitizedGrid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="h6">
                School, Academic Year and Holiday Type
              </Typography>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select School"
                source="schoolId"
                reference="schools"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}>
              <ReferenceInput
                label="Select Academic Year"
                source="academicYearId"
                reference="academicYears"
                disabled
              >
                <AutocompleteInput optionText="name" />
              </ReferenceInput>
            </Grid>
            <Grid item xs={4}></Grid>

            <Grid item xs={4}>
              <AutocompleteInput source="type" choices={typeList} disabled />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="h6">Details</Typography>
            </Grid>
            <Grid item xs={4}>
              <TextInput source="name" validate={required()} />
            </Grid>
            <Grid item xs={4}>
              <CustomEndDateInput
                source="date"
                parentStartDate={moment
                  .utc(academicYearResources?.startDate)
                  .format("yyyy-MM-DD")}
                parentEndDate={moment
                  .utc(academicYearResources?.endDate)
                  .format("yyyy-MM-DD")}
                excludeDates={excludeDates}
              />
            </Grid>
          </SanitizedGrid>
        </SimpleForm>
      </EditWrapper>
    </>
  );
};

export default HolidayEdit;
